import { render, staticRenderFns } from "./ProgressLogo.vue?vue&type=template&id=039be823&scoped=true&"
var script = {}
import style0 from "./ProgressLogo.vue?vue&type=style&index=0&id=039be823&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039be823",
  null
  
)

export default component.exports